import type { ModalProps } from '@components/moleculs/modal/types';
import { MODAL_WIDTH } from '@constants';
import MuiModal from '@mui/material/Dialog';
import styled from 'styled-components';

export const Modal = styled(MuiModal)<ModalProps>`
    .MuiDialog-container {
        > .MuiPaper-root {
            width: ${(props) => props.width ?? MODAL_WIDTH.DEFAULT};
            max-width: ${(props) => props.contentMaxWidth ?? ''};
            background: ${(props) => props.contentBackground ?? ''};
            margin: 0 15px;
            border-radius: 8px;
            border: none;

            ${(props) => props.theme.breakpointTo.md} {
                max-height: calc(100% - 30px);
            }
        }
    }

    .closer {
        position: absolute;
        top: 31px;
        right: 31px;
        z-index: 100;

        ${(props) => props.theme.breakpointTo.md} {
            top: 25px;
            right: 23px;
        }
    }
`;

type ModalBodyProps = {
    minHeight?: string;
};

export const ModalBody = styled.div<ModalBodyProps>`
    min-height: ${(props) => props.minHeight ?? ''};
`;
